/**
 * @file ThemeToggle.js — Bouton de bascule entre thème clair et sombre.
 * Utilise next-themes pour persister la préférence dans localStorage
 * et synchroniser la classe CSS « dark » sur la balise <html>.
 * Détecte automatiquement la préférence système au premier chargement (R-0024).
 */
import { useTheme } from 'next-themes';
import { Sun, Moon } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Bouton icône qui alterne entre le thème clair (Sun) et sombre (Moon).
 * @returns {React.ReactElement}
 */
export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-8 w-8 min-h-[44px] min-w-[44px]"
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      data-testid="theme-toggle"
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
    </Button>
  );
}
